import RegistryMcom from './Registry.mcom';
import RegistryBcom from './Registry.bcom';

export default import.meta.env.VITE_ENTRY_POINT === 'bcom' ? RegistryBcom : RegistryMcom;
